import React, { FC, ReactNode, useRef } from "react";

interface AccordionProps {
  isOpen: boolean;
  children: ReactNode;
}

const Accordion: FC<AccordionProps> = ({ isOpen, children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const height = ref?.current?.scrollHeight;
  const style = {
    transition: 'height 300ms ease',
    height: isOpen && height ? height : 0,
  };

  return (
    <div ref={ref} style={style}>
      {children}
    </div>
  );
};

export default Accordion;